import React, { useEffect, useState } from 'react';
import { fetchAPI } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';

export default function SecurityHandler() {
    const { currentUser } = useAuth();
    const [config, setConfig] = useState({
        dev_tools_restricted: '0',
        right_click_restricted: '0',
        developer_mode_active: '1'
    });

    useEffect(() => {
        const loadConfig = async () => {
            try {
                const response = await fetchAPI('/admin/get_settings.php');
                setConfig(response);
            } catch (err) {
                console.warn("Security config fetch failed, using defaults");
            }
        };
        loadConfig();

        // Refresh config every 5 minutes
        const interval = setInterval(loadConfig, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Master switch check
        if (config.developer_mode_active === '0') return;

        const handleContextMenu = (e) => {
            // Only bypass for Admin for Right-Click/Keys if we want to allow them to work
            if (currentUser?.role === 'admin') return;
            if (config.right_click_restricted === '1') {
                e.preventDefault();
                return false;
            }
        };

        const handleKeyDown = (e) => {
            if (currentUser?.role === 'admin') return;
            if (config.dev_tools_restricted === '0') return;

            // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
            if (e.keyCode === 123 ||
                (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) ||
                (e.ctrlKey && e.keyCode === 85)) {
                e.preventDefault();
                return false;
            }
        };

        // Aggressive Console Suppression - APPLY TO EVERYONE if enabled
        let consoleInterval;
        if (config.dev_tools_restricted === '1') {
            const suppress = () => { };
            // Replace all major console methods
            ['log', 'error', 'warn', 'info', 'debug', 'table', 'trace', 'dir'].forEach(method => {
                window.console[method] = suppress;
            });

            // Periodically clear the console to remove logs from late-loading iframes (like Zoom)
            console.clear();
            consoleInterval = setInterval(() => {
                console.clear();
            }, 1000); // Every second to keep it clean
        }

        window.addEventListener('contextmenu', handleContextMenu);
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('contextmenu', handleContextMenu);
            window.removeEventListener('keydown', handleKeyDown);
            if (consoleInterval) clearInterval(consoleInterval);
        };
    }, [config, currentUser]);

    return null; // This component doesn't render anything
}
